import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { NgbActiveModal, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";

@Component({
    selector: "rask-tpl-tilldelning-warning-modal",
    templateUrl: "./tpl-tilldelning-warning-modal.component.html",
    styleUrls: ["./tpl-tilldelning-warning-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        ButtonComponent,
        TranslatePipe
    ]
})
export class TplTilldelningWarningModalComponent {
    readonly activeModal = inject(NgbActiveModal);

    arbetsorderNamn: string;

    private readonly translate = inject(TranslateService);

    static open(
        arbetsorderNamn: string,
        modalService: NgbModal,
        callBack: (result: any) => void = null) {
        const options = {
            keyboard: false,
            backdrop: "static",
            size: "m",
            centered: true
        } as NgbModalOptions;
        const modalRef = modalService.open(this, options);
        modalRef.componentInstance.arbetsorderNamn = arbetsorderNamn;

        if (callBack) {
            modalRef.result.then(r => callBack(r));
        } else {
            modalRef.result.then(r => modalRef.close(r));
        }
    }

    close() {
        this.activeModal.close();
    }
}
